import { observer } from 'mobx-react-lite';
import { CategoriesColumn } from './CategoriesColumn';
import { SubCategoriesColumn } from './SubCategoriesColumn';
import { OptionSubCategory } from 'owa-options-core';
import { getCurrentSubcategory } from 'owa-options-store';
import SettingsColumn from './SettingsColumn';
import { useOptionLayout, OptionLayout } from './hooks/useOptionLayout';
import { useFlyoutState } from './hooks/useFlyoutState';
import { FlyoutLevel } from './hooks/useFlyoutLevelState';
import { SettingsOverlay } from './SettingsOverlay';
import * as React from 'react';

/**
 * Content of the options modal after all allowed subcategories have been loaded in store
 */
function OptionsFullWithLoadedCategoriesContentInner(props: {}) {
    let selectedSubCategory: OptionSubCategory =
        getCurrentSubcategory() || ({} as OptionSubCategory);
    const layout = useOptionLayout();
    const {
        onCategorySelect,
        onSubCategorySelect,
        onSoftDismiss,
        onOpenFlyout,
        flyoutLevel,
        flyoutCategory,
        onNavigateBackFromSubcategories,
    } = useFlyoutState();

    return (
        <>
            {(layout === OptionLayout.ThreeColumn || layout === OptionLayout.TwoColumn) && (
                <CategoriesColumn
                    onCategorySelect={onCategorySelect}
                    selectedCategoryKey={flyoutCategory?.key}
                />
            )}
            {layout === OptionLayout.ThreeColumn && <SubCategoriesColumn />}
            <SettingsColumn onOpenFlyout={onOpenFlyout} />
            {flyoutLevel !== FlyoutLevel.Closed && (
                <SettingsOverlay
                    selectedSubCategoryKey={selectedSubCategory.key}
                    onSoftDismiss={onSoftDismiss}>
                    {!!(flyoutLevel & FlyoutLevel.Categories) && (
                        <CategoriesColumn
                            onCategorySelect={onCategorySelect}
                            selectedCategoryKey={flyoutCategory?.key}
                        />
                    )}
                    {!!(flyoutLevel & FlyoutLevel.Subcategories) && (
                        <SubCategoriesColumn
                            onSubCategorySelect={onSubCategorySelect}
                            category={flyoutCategory}
                            onNavigateBack={onNavigateBackFromSubcategories}
                        />
                    )}
                </SettingsOverlay>
            )}
        </>
    );
}
export default observer(OptionsFullWithLoadedCategoriesContentInner);
